import { loadable } from 'utils';

export const Verification = loadable(() => import('./Verification'), {});
export const Seller = loadable(() => import('./Seller'), {});
export const Institution = loadable(() => import('./Institution'), {});
export const Address = loadable(() => import('./Address'), {});
